import * as React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCcMastercard, faCcVisa} from "@fortawesome/free-brands-svg-icons";
import {IconProp} from "@fortawesome/fontawesome-svg-core";
import {faBuildingColumns, faCreditCard, faMoneyCheckPen, faSquareQuestion} from "@fortawesome/pro-regular-svg-icons";
import {useIntl} from "react-intl";

type Props = {
    paymentMethodType: string
    cardBrand?: string | null
    className?: string
}

const PaymentMethodIcon: React.FC<Props> = ({paymentMethodType, cardBrand, className = "h-5 w-5"}) => {
    const intl = useIntl();
    let icon: IconProp;

    switch (paymentMethodType) {
        case 'Card': {
            switch (cardBrand) {
                case 'Visa':
                    icon = faCcVisa;
                    break;
                case 'Mastercard':
                    icon = faCcMastercard;
                    break;
                default:
                    icon = faCreditCard;
                    break;
            }
            break;
        }
        case 'SepaDebit': {
            icon = faBuildingColumns;
            break;
        }
        case 'OnAccount': {
            icon = faMoneyCheckPen;
            break;
        }
        default: {
            icon = faSquareQuestion;
        }
    }

    return <FontAwesomeIcon icon={icon} className={className} title={intl.formatMessage({id: 'paymentMethod.' + paymentMethodType})} />;
};

export default PaymentMethodIcon;
